import React from "react";

import Stories from "../components/stories/stories";

import posts from "../content/blog/posts.generated.json";

// About Me page: the full life-story feed — every story, not only highlights.
const About = () => {
    return (
        <div className="about-page">
            <h1 id="About">About Me</h1>
            <Stories posts={posts}></Stories>
        </div>
    );
};

export default About;
